import useViewWalk from 'lib/hooks/api/useViewWalk'

type UseIWitnessActivityId = (
  walkSlug: string,
  enabled?: boolean
) => number | undefined

const useIWitnessActivityId: UseIWitnessActivityId = (walkSlug, enabled) => {
  const { data } = useViewWalk(walkSlug, enabled)

  return data?.ActivityID
}

export default useIWitnessActivityId
